// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
$w("#readMoreButton1").onClick(() => {
    $w("#readMoreStatebox1").changeState("expandedState1");
});

$w("#readLessButton1").onClick(() => {
    $w("#readMoreStatebox1").changeState("collapsedState1");
});

$w("#readMoreButton2").onClick(() => {
    $w("#readMoreStatebox2").changeState("expandedState2");
});

$w("#readLessButton2").onClick(() => {
    $w("#readMoreStatebox2").changeState("collapsedState2");
});

$w("#readMoreButton3").onClick(() => {
    $w("#readMoreStatebox3").changeState("expandedState3");
});

$w("#readLessButton3").onClick(() => {
    $w("#readMoreStatebox3").changeState("collapsedState3");
});

$w("#readMoreButton4").onClick(() => {
    $w("#readMoreStatebox4").changeState("expandedState4");
});

$w("#readLessButton4").onClick(() => {
    $w("#readMoreStatebox4").changeState("collapsedState4");
});

$w("#readMoreButton5").onClick(() => {
    $w("#readMoreStatebox5").changeState("expandedState5");
});

$w("#readLessButton5").onClick(() => {
	$w("#readMoreStatebox5").changeState("collapsedState5");
});
});